module.exports = __webpack_public_path__ + "img/minna.3679a2f0.png";